import Vue from 'vue';
import VueI18n from 'vue-i18n';
import fr from '../lang/fr'
import en from '../lang/en'
import es from '../lang/es'
import ru from '../lang/ru'
import de from '../lang/de'

Vue.use(VueI18n);

const messages = {
    'fr': fr,
    'en': en,
    'es': es,
    'ru': ru,
    'de': de
};

const i18n = new VueI18n({
    locale: 'fr', // set locale
    fallbackLocale: 'en', // set fallback locale
    messages, // set locale messages
});

export default i18n;